export class CreateFromStandardAudit
{
    constructor(){
        this.Properties=[];
        this.NotificationTemplates=[];
      }
    AuditID:string;
    CustomerID:number;
    CustomerAccountName:string;
    CustomerAccountID:string;
    AuditAmadeus:boolean;
    AuditApollo:boolean;
    AuditGalileo:boolean;
    AuditSabre:boolean;
    AuditWorldspan:boolean;
    AmadeusRAC:string;
    ApolloRAC:string;
    GalileoRAC:string;
    SabreRAC:string;
    WorldspanRAC:string;
    MaxSearchRadius:number;
    RvrAuditPoints:number;
    RACFilters:string;
    ContractYear:number;
    SabrePCC:string;

    Properties: Property[];
    ChainCodes:string;
    NotificationTemplates:NotificationTemplates[];

}

export class NotificationTemplates
{
   TemplateIdGuid:string;
   IsDefault:boolean;
   Name:string;
}
export class Property
{
    IsChecked:boolean;
    AuditPropertyID:string;
    AuditID:string;
    PropertyName:string
    PropertyAddress:string;
    PropertyCity:string;
    PropertyStateProvince:string;
    PropertyPostalCode:string;
    PropertyCountry:string;
    PropertyContactPhone:string;
    PropertyContactName:string;
    PropertyContactEMail:string;
    AmadeusChainCode:string;
    AmadeusPropCode:string;
    AmadeusRAC:string;
    ApolloChainCode:string;
    ApolloPropCode:string;
    ApolloRAC:string;
    CurrencyCode:string;
    LRA:boolean;
    GalileoChainCode:string;
    GalileoPropCode:string;
    GalileoRAC:string;
    SabreChainCode:string;
    SabrePropCode:string;
    SabreRAC:string;
    Season1End:Date;
    Season1ExpectedPrice:number;
    Season1Start:Date;
    WorldspanChainCode:string;
    WorldspanPropCode:string;
    WorldspanRAC:string;
}
